import { Payment, initMercadoPago, StatusScreen } from "@mercadopago/sdk-react";
import { chargeByStripeSckecout } from "../../../../services/cartService";
import useAuth from "../../../../hooks/context/useAuth";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { colors } from "../../../../theme/colors";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { amber } from "@mui/material/colors";
initMercadoPago(process.env.REACT_APP_MERCAGO_PAGO_KEY, { locale: "pt-BR" });
interface Props {
  selectedProducts: CartXProduct[];
  itensInfo: { totalValue: number; totalItens: number; addressID: number };
  freteType: { freteType: string; value: string };
  disablePayButton(): void;
}

export function MercadoPagoPayment({
  selectedProducts,
  itensInfo,
  freteType,
  disablePayButton,
}: Props) {
  const [paymentError, setPaymentError] = useState(false);
  const [payStatus, setStatus] = useState({ open: false, payID: null });
  const { user } = useAuth();
  const nav = useNavigate();

  const onSubmit = async ({ formData }) => {
    // callback chamado ao clicar no botão de submissão dos dados
    try {
      const payload = {
        selectedProducts,
        frete: { ...freteType },
        info: {
          userID: user?.user?.id,
          totalValue: itensInfo.totalValue,
          addressId: itensInfo.addressID,
        },
      };
      const response = await chargeByStripeSckecout({ formData, ...payload });

      setStatus({ payID: response.result.id, open: true });
      disablePayButton();

      if (response.result.payment_type_id === "ticket") {
        nav(`/checkout/success-pay?orderID=${response.orderID}`);
      }

      if (["in_process", "approved"].includes(response.result.status as any)) {
        nav(`/checkout/success-pay?orderID=${response.orderID}`);
      }
    } catch (e) {
      setPaymentError(true);
    }
  };
  const onError = async (error) => {
    // callback chamado para todos os casos de erro do Brick
  };
  const onReady = async () => {
    // rejected
  };

  const mapToCharge = selectedProducts.map((item) => ({
    name: item.product.name,
    units: item.quantity,
    value: Number(
      (
        (item.product.discountPrice > 0
          ? item.product.discountPrice
          : item.product.price) / 100
      ).toFixed(2)
    ),
    description: "",
    imageURL: item.product.productsImages[0].code,
  }));

  const total = Number(
    (
      selectedProducts.reduce((acc, next) => {
        if (next?.product?.discountPrice > 0) {
          return acc + next?.product?.discountPrice * next.quantity;
        }
        return acc + next.product.price * next.quantity;
      }, 0) / 100
    ).toFixed(2)
  );

  return (
    <>
      {paymentError ? (
        <Box
          sx={{
            background: "#FFFFFF",
            borderRadius: 5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            flexDirection: "column",
          }}
        >
          <ReportProblemIcon
            style={{ fill: amber[500], marginTop: 30, fontSize: 50 }}
          />
          <Typography
            fontSize={18}
            color={colors.purple[500]}
            fontWeight={500}
            pl={3}
            pr={3}
            pt={3}
          >
            A operadora do seu cartão não autorizou o pagamento
          </Typography>
          <Typography
            pl={3}
            pr={3}
            pb={3}
            fontSize={20}
            color={colors.purple[500]}
            fontWeight={500}
          >
            Clique abaixo para tentar novamente ou selecionar outro método de
            pagamento
          </Typography>

          <Button
            variant="contained"
            onClick={() => setPaymentError(false)}
            sx={{ mb: 5 }}
          >
            Pagar
          </Button>
        </Box>
      ) : payStatus.open ? (
        <Box sx={{ background: "#FFFFFF", borderRadius: 5 }}>
          <Typography
            sx={{ p: 2, fontWeight: 500, color: colors.textGrey[400] }}
          >
            Após realizar o pagamento por pix, enviaremos um e-mail da
            confirmação, você também pode verificar os tatus do pedido em seus
            pedidos.
          </Typography>
          <StatusScreen initialization={{ paymentId: payStatus?.payID }} />
        </Box>
      ) : (
        <Payment
          initialization={{
            items: {
              itemsList: [...mapToCharge],
              totalItemsAmount: total + Number(freteType.value),
            },
            amount: total + Number(freteType.value),
          }}
          customization={{
            visual: {
              style: {
                theme: "flat",
              },
            },
            paymentMethods: {
              // ticket: "all",
              creditCard: "all",
              debitCard: "all",
              bankTransfer: "all",
            },
          }}
          onSubmit={onSubmit}
          onReady={onReady}
          onError={onError}
        />
      )}
    </>
  );
}
